import Vue from 'vue'
import $store from '@/code-lab/store'

import { store } from '@/code-lab/component/robot-connect/device-manage/observable/store.js'
import { mutations as playButtonMutations } from '@/code-lab/component/robot-connect/play-button/observable.js'
import { RobotHanlde } from '@/service/toolClass.js'
import { obserState, update as obserStateUpdate } from '@/code-lab/component/robot-connect/play-button/microstate/playState.js'
async function closeConnect (sb) {
    const that = new Vue()
    that.b$.close("rms")
    if ($store.state.currentVersion !== 'teacher') {
        if (obserState.inProgressIs === 3 && !sb) {
            await new Promise(rs => {
                obserStateUpdate({ key: 'stopOr', val: true })
                that.b$.catchCallBack('quick', 'ws.cmd.update_robot_code_lab_stop', () => {
                    that.$message({ type: "success", message: Vue.prototype.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_12" ), duration: 5000, customClass: "socketErrorCodeClass_g" })
                    setTimeout(() => rs(), 1000)
                })
                new RobotHanlde().set_code_execute('quick', that.b$).then(() => {
                    that.$message({ type: "success", message: Vue.prototype.$t( "code-lab/component/robot-connect/play-button/play-on-robot.vue_14" ), duration: 3000, customClass: "socketErrorCodeClass_g" })
                })
            })
        }
    }
    console.log('close')
    obserStateUpdate({ key: 'inProgressIs', val: 0 })
    that.b$.close("quick")
    store.commit("pop/connectPopStatus", { connectPopStatus: "connect" })
    console.log('close')

    if ($store.state.currentVersion !== 'teacher') {
        store.commit("button/connectButtonStatus", { connectButtonStatus: "connect.quickNormal" })
        store.commit("button/current", { current: 2 }) 
        playButtonMutations.status({ status: 0 })
    } else {
        store.commit("button/connectButtonStatus", { connectButtonStatus: "connect.normal" })
        store.commit("button/current", { current: 0 })
    }
    store.commit("pop/switchIs", { switchIs: false })
    store.commit("button/clickData", { clickData: false })
    
    $store.commit("rmsConnection/HANDLECONNECTDEVICES", []) 
    $store.commit("teachConnection/HANDLECONNECTDEVICES", []) 
    $store.commit('handleConnectGolbalState', null)
    $store.commit("SET_ROBOT_FAMILIES", [])

}
export {
    closeConnect
}
